import { render, staticRenderFns } from "./CreateAnnotationButton.vue?vue&type=template&id=015568d8&scoped=true"
import script from "./CreateAnnotationButton.vue?vue&type=script&lang=ts"
export * from "./CreateAnnotationButton.vue?vue&type=script&lang=ts"
import style0 from "./CreateAnnotationButton.vue?vue&type=style&index=0&id=015568d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015568d8",
  null
  
)

export default component.exports